/*
 * ScaleRaphael 0.8 by Zevan Rosser 2010
 * For use with Raphael library : www.raphaeljs.com
 * Licensed under the MIT license.
 *
 * www.shapevent.com/scaleraphael/
 */
(function(){
  window.ScaleRaphael = function(container, width, height){
    var wrapper = document.getElementById(container);
    if (!wrapper.style.position) wrapper.style.position = "relative";
    wrapper.style.width = width + "px";
    wrapper.style.height = height + "px";
    wrapper.style.overflow = "hidden";

    var nestedWrapper;

    if (Raphael.type == "VML"){
      wrapper.innerHTML = "<rvml:group style='position : absolute; width: 1000px; height: 1000px; top: 0px; left: 0px' coordsize='1000,1000' class='rvml' id='vmlgroup'><\/rvml:group>";
      nestedWrapper = document.getElementById("vmlgroup");
    }else{
      wrapper.innerHTML = "<div id='svggroup'><\/div>";
      nestedWrapper = document.getElementById("svggroup");
    }

    var paper = new Raphael(nestedWrapper, width, height);
    var vmlDiv;

    if (Raphael.type == "SVG"){
      paper.canvas.setAttribute("viewBox", "0 0 "+width+" "+height);
    }else{
      vmlDiv = wrapper.getElementsByTagName("div")[0];
    }

    paper.changeSize = function(w, h, center, clipping){
      clipping = !clipping;

      var ratioW = w / width;
      var ratioH = h / height;
      var scale = ratioW < ratioH ? ratioW : ratioH;

      var newHeight = parseInt(height * scale);
      var newWidth = parseInt(width * scale);

      if (Raphael.type == "VML"){
        // scale the textpaths
        var txt = document.getElementsByTagName("textpath");
        for (var i in txt){
          var curr = txt[i];
          if (curr.style){
            if(!curr._fontSize){
              var mod = curr.style.font.split("px");
              curr._fontSize = parseInt(mod[0]);
              curr._font = mod[1];
            }
            curr.style.font = curr._fontSize * scale + "px" + curr._font;
          }
        }
        var newSize;
        if (newWidth < newHeight){
          newSize = newWidth * 1000 / width;
        }else{
          newSize = newHeight * 1000 / height;
        }
        newSize = parseInt(newSize);
        nestedWrapper.style.width = newSize + "px";
        nestedWrapper.style.height = newSize + "px";
        if (clipping){
          nestedWrapper.style.left = parseInt((w - newWidth) / 2) + "px";
          nestedWrapper.style.top = parseInt((h - newHeight) / 2) + "px";
        }
        vmlDiv.style.overflow = "visible";
      }

      if (clipping){
        newWidth = w;
        newHeight = h;
      }

      wrapper.style.width = newWidth + "px";
      wrapper.style.height = newHeight + "px";
      paper.setSize(newWidth, newHeight);

      if (center){
        wrapper.style.position = "absolute";
        wrapper.style.left = parseInt((w - newWidth) / 2) + "px";
        wrapper.style.top = parseInt((h - newHeight) / 2) + "px";
      }
    }

    paper.scaleAll = function(amount){
      paper.changeSize(width * amount, height * amount);
    }

    paper.panzoom = function (options) {
      var paper = this;
      return new PanZoom(paper, options);
    }

    paper.changeSize(width, height);

    paper.w = width;
    paper.h = height;

    return paper;
  }

  function findPos(obj) {
    var posX = obj.offsetLeft, posY = obj.offsetTop, posArray;
    while (obj.offsetParent) {
      if (obj === document.getElementsByTagName('body')[0]) {
        break;
      } else {
        posX = posX + obj.offsetParent.offsetLeft;
        posY = posY + obj.offsetParent.offsetTop;
        obj = obj.offsetParent;
      }
    }
    return [posX, posY];
  }

  function getRelativePosition(e, obj) {
    var x, y, pos;

    if (e instanceof TouchEvent) {
      e = e.touches[0];
    }

    if (e.pageX || e.pageY) {
      x = Math.ceil(e.pageX);
      y = Math.ceil(e.pageY);
    } else {
      x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    pos = findPos(obj);
    x -= pos[0];
    y -= pos[1];

    return { x: x, y: y };
  }

  PanZoom = function (el, options) {
    let paper = el,
        pos = { x: 0, y: 0 },
        container = paper.canvas.parentNode,
        me = this,
        settings = {},
        initialPos = { x: 0, y: 0 },
        deltaX = 0,
        deltaY = 0,
        mousewheelevt = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";

    this.enabled = true;
    this.dragThreshold = 5;
    this.dragTime = 0;

    options = options || {};

    settings.maxZoom = options.maxZoom || 9;
    settings.minZoom = options.minZoom || 0;
    settings.zoomStep = options.zoomStep || 0.1;
    settings.initialZoom = options.initialZoom || 0;
    settings.initialPosition = options.initialPosition || { x: 0, y: 0 };

    this.currZoom = settings.initialZoom;
    this.currPos = settings.initialPosition;

    function repaint() {
      me.currPos.x = me.currPos.x + deltaX;
      me.currPos.y = me.currPos.y + deltaY;

      let newWidth = paper.width * (1 - (me.currZoom * settings.zoomStep));
      let newHeight = paper.height * (1 - (me.currZoom * settings.zoomStep));

      if (me.currPos.x < 0) {
        me.currPos.x = 0;
      } else if (me.currPos.x > (paper.width * me.currZoom * settings.zoomStep)) {
        me.currPos.x = (paper.width * me.currZoom * settings.zoomStep);
      }

      if (me.currPos.y < 0) {
        me.currPos.y = 0;
      } else if (me.currPos.y > (paper.height * me.currZoom * settings.zoomStep)) {
        me.currPos.y = (paper.height * me.currZoom * settings.zoomStep);
      }
      paper.setViewBox(me.currPos.x, me.currPos.y, newWidth, newHeight);
    }

    function dragging(e) {
      if (!me.enabled) {
        return false;
      }
      var evt = window.event || e,
        newWidth = Math.ceil(paper.width * (1 - (me.currZoom * settings.zoomStep))),
        newHeight = Math.ceil(paper.height * (1 - (me.currZoom * settings.zoomStep))),
        newPoint = getRelativePosition(evt, container);

      deltaX = (newWidth * (newPoint.x - initialPos.x) / paper.width) * -1;
      deltaY = (newHeight * (newPoint.y - initialPos.y) / paper.height) * -1;
      initialPos = newPoint;

      repaint();
      me.dragTime += 1;
      if (evt.preventDefault) {
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      return false;
    }

    function applyZoom(val, centerPoint) {
      if (!me.enabled) {
        return false;
      }
      me.currZoom += val;
      if (me.currZoom < settings.minZoom) {
        me.currZoom = settings.minZoom;
      } else if (me.currZoom > settings.maxZoom) {
        me.currZoom = settings.maxZoom;
      } else {
        centerPoint = centerPoint || { x: paper.width / 2, y: paper.height / 2 };

        deltaX = ((paper.width * settings.zoomStep) * (centerPoint.x / paper.width)) * val;
        deltaY = (paper.height * settings.zoomStep) * (centerPoint.y / paper.height) * val;

        repaint();
      }
    }

    this.applyZoom = applyZoom;

    function handleScroll(e) {
      if (!me.enabled) {
        return false;
      }
      var evt = window.event || e,
        delta = evt.detail || evt.wheelDelta * -1,
        zoomCenter = getRelativePosition(evt, container);

      if (delta > 0) {
        delta = -1;
      } else if (delta < 0) {
        delta = 1;
      }

      applyZoom(delta, zoomCenter);
      if (evt.preventDefault) {
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      return false;
    }

    repaint();

    container.onmousedown = function (e) {
      var evt = window.event || e;
      if (!me.enabled) {
        return false;
      }
      me.dragTime = 0;
      initialPos = getRelativePosition(evt, container);
      container.className += " grabbing";
      container.onmousemove = dragging;
      document.onmousemove = function () { return false; };
      if (evt.preventDefault) {
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      return false;
    };

    container.onmouseup = function (e) {
      // Remove class framework independent
      document.onmousemove = null;
      container.className = container.className.replace(/(?:^|\s)grabbing(?!\S)/g, '');
      container.onmousemove = null;
    };

    if (container.attachEvent) {//if IE (and Opera depending on user setting)
      container.attachEvent("on" + mousewheelevt, handleScroll);
    } else if (container.addEventListener) {//WC3 browsers
      container.addEventListener(mousewheelevt, handleScroll, false);
    }

    function applyPan(dX, dY) {
      deltaX = dX;
      deltaY = dY;
      repaint();
    }

    function enable() {
      this.enabled = true;
    }

    function disable() {
      this.enabled = false;
    }

    function zoomIn(steps) {
      steps = 1;
      this.applyZoom(steps);
    }

    function zoomOut(steps) {
      steps = 1;
      this.applyZoom(steps > 0 ? steps * -1 : steps);
    }

    function pan(deltaX, deltaY) {
      this.applyPan(deltaX * -1, deltaY * -1);
    }

    function moveMe(x, y) {
      let newWidth = Math.ceil(paper.width * (1 - (me.currZoom * settings.zoomStep)));
      let newHeight = Math.ceil(paper.height * (1 - (me.currZoom * settings.zoomStep)));

      let ratioX = (newWidth * x / paper.width);
      let ratioY = (newHeight * y / paper.height);

      deltaX = ratioX * -1;
      deltaY = ratioY * -1;

      deltaX /= 15;
      deltaY /= 15;

      repaint();
    }

    function isDragging() {
      return this.dragTime > this.dragThreshold;
    }

    function getCurrentPosition() {
      return this.currPos;
    }

    function getCurrentZoom() {
      return this.currZoom;
    }


    this.applyPan = applyPan;
    this.enable = enable;
    this.zoomIn = zoomIn;
    this.zoomOut = zoomOut;
    this.pan = pan;
    this.drag = dragging;
    this.moveMe = moveMe;
    this.repaint = repaint;
  };
})();
